import React, { Component } from 'react';
import 'react-day-picker/dist/style.css';
import { detectIOS, getStyleFromInnerWidth } from '../../utilities/helperUtility';
import { StyledDatePicker } from './DatePicker.style';

let localeImports = {};

if (process.env.NODE_ENV !== 'test') {
  localeImports = import.meta.glob('../../../../../node_modules/date-fns/esm/locale/*/index.js');
}

export default class DatePicker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      padding: '5px',
      localization: null,
    };

    this.onDayClick = this.onDayClick.bind(this);
    this.handleDayMouseEnter = this.handleDayMouseEnter.bind(this);
    this.handleDayMouseLeave = this.handleDayMouseLeave.bind(this);
    this.onMonthChange = this.onMonthChange.bind(this);
  }

  componentDidMount() {
    const { region = 'en-US' } = this.props;
    let newRegion = region;

    if (region.includes('-')) {
      const [language, country] = region.split('-');
      newRegion = `${language}-${country.toUpperCase()}`;
    }

    try {
      localeImports[`../../../../../node_modules/date-fns/esm/locale/${newRegion}/index.js`]().then((module) => {
        const newModule = module;
        if (newRegion === 'en-AU') {
          newModule.default.options = {
            weekStartsOn: 0,
          };
        }
        this.setState({ localization: newModule.default });
      });
    } catch (e) {
      // locale is not found, fallback to en
    }

    window.addEventListener('resize', this.getStyles.bind(this));
    this.getStyles();
  }

  onMonthChange(value) {
    const { onMonthChange } = this.props;
    onMonthChange(value);
  }

  onDayClick(day, modifiers = {}) {
    const { onDayClick } = this.props;
    onDayClick(day, modifiers);
  }

  getStyles() {
    const { styled } = this.props;
    const { padding, fontSize } = getStyleFromInnerWidth(styled);

    this.setState({ padding, fontSize });
  }

  handleDayMouseEnter(day, modifiers, e) {
    const { handleDayMouseEnter } = this.props;
    if (detectIOS() && !window.matchMedia('(pointer:fine)').matches) {
      this.onDayClick(day, modifiers);
    } else if (handleDayMouseEnter) {
      handleDayMouseEnter(day, e);
    }
  }

  handleDayMouseLeave() {
    const { handleDayMouseLeave } = this.props;
    handleDayMouseLeave?.();
  }

  render() {
    const { renderDay, children, className = '', shopBeginningOfWeek } = this.props;
    const { padding, fontSize, localization } = this.state;
    const customStyle = { padding, fontSize };
    let originProps = { ...this.props };
    const weekStartsOn = parseInt(shopBeginningOfWeek);
    const isCustomWeekStart = !isNaN(weekStartsOn);

    if (isCustomWeekStart) {
      originProps = { ...originProps, ...{ weekStartsOn } };
    }

    return (
      <div className={`date-picker-container ${className}`}>
        <StyledDatePicker
          {...originProps}
          customStyle={customStyle}
          locale={localization}
          onDayClick={this.onDayClick}
          onDayMouseEnter={this.handleDayMouseEnter}
          onDayMouseLeave={this.handleDayMouseLeave}
          onMonthChange={this.onMonthChange}
          renderDay={renderDay}
        >
          {children}
        </StyledDatePicker>
      </div>
    );
  }
}
